import React from 'react';
import { SubscribeForm } from './SubscribeForm';
import { InquiryForm } from './InquiryForm';
export function ContactSection() {
  return <>
      <div className="h-24 bg-gradient-to-b from-black via-[#0a1418] to-[#0c1a1f]" data-id="element-590" />

      <section className="relative overflow-hidden" data-id="element-591">
        <div className="absolute inset-0 bg-gradient-to-b from-[#0c1a1f] via-[#0d1519] to-[#080c0e] z-0" data-id="element-592" />
        <div className="relative z-10 grid grid-cols-1 lg:grid-cols-2" data-id="element-593">
          <SubscribeForm data-id="element-594" />
          <InquiryForm data-id="element-595" />
        </div>
      </section>
    </>;
}